import React from "react";
import "./PaymentSuccess.css";
import { useNavigate } from "react-router-dom";

const CheckCircleIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="check-circle-icon"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const lastVisitedPage = localStorage.getItem('lastVisitedPage')

  return (
    <div className="payment-container">
      <div className="payment-card">
        <div className="icon-container">
          <CheckCircleIcon />
        </div>
        <h1 className="payment-title">Payment Successful!</h1>
        <p className="payment-message">
          Thank you for your purchase.
          {/* We've sent a confirmation email with your
          order details. */}
        </p>

        {/* <div className="payment-details">
                    <div className="detail-row">
                        <span className="detail-label">Order ID</span>
                        <span className="detail-value">{orderDetails.orderId}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Amount Paid</span>
                        <span className="detail-value">{orderDetails.amount}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Date</span>
                        <span className="detail-value">{orderDetails.date}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Email</span>
                        <span className="detail-value">{orderDetails.email}</span>
                    </div>
                </div> */}

        <div className="button-group">
          <button
            className="print-button"
            onClick={() => {
              navigate(lastVisitedPage)
            }}
          >
            Go back
          </button>
          {/* <button className="print-button" onClick={() => window.print()}>
              Print Receipt
            </button> */}
          {/* <button className="view-orders-button" onClick={() => window.location.href = '/orders'}>View Orders</button> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
